import { useQuery } from '@apollo/client'

import { ActiveCompanyContext } from 'contexts'

import { CompanyFields, CompanyFieldsVariables, COMPANY_FIELDS } from './api'
import { useSeason } from '../useSeason'

export const useHasCompanyOrFieldsOrLots = () => {
  const { activeCompanyId, activeSeasonId, loadingCompanySeasons } =
    ActiveCompanyContext.useActiveCompanyContext()

  const { data: season, loading: loadingSeason } = useSeason(activeSeasonId)

  const { data: companyFields, loading: loadingCompanyFields } = useQuery<
    CompanyFields,
    CompanyFieldsVariables
  >(COMPANY_FIELDS, {
    variables: { id: activeCompanyId! },
    skip: !activeCompanyId,
  })

  const noCompany = !activeCompanyId
  const noFields = !companyFields?.company.fields?.length
  const noLots =
    !noCompany &&
    !noFields &&
    !season?.season.seasonFields.some(seasonField => !!seasonField.lots?.length)
  const noCompanyOrFieldsOrLots = noCompany || noFields || noLots

  const loading =
    loadingCompanySeasons ||
    loadingSeason ||
    loadingCompanyFields ||
    (!!activeCompanyId && (!companyFields || !season))

  return { noCompanyOrFieldsOrLots, noCompany, noFields, noLots, loading }
}
